import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from '@/locales/en/common.json';
import enWallet from '@/locales/en/wallet.json';
import enSchedules from '@/locales/en/schedules.json';
import enPurchases from '@/locales/en/purchases.json';
import enInterest from '@/locales/en/interest.json';

import esCommon from '@/locales/es/common.json';
import esWallet from '@/locales/es/wallet.json';
import esSchedules from '@/locales/es/schedules.json';
import esPurchases from '@/locales/es/purchases.json';
import esInterest from '@/locales/es/interest.json';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        wallet: enWallet,
        schedules: enSchedules,
        purchases: enPurchases,
        interest: enInterest,
      },
      es: {
        common: esCommon,
        wallet: esWallet,
        schedules: esSchedules,
        purchases: esPurchases,
        interest: esInterest,
      },
    },
    defaultNS: 'common',
    supportedLngs: ['en', 'es'],
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['navigator', 'localStorage'],
      caches: ['localStorage'],
    },
  });

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
